export const ConfirmModal = (props) => {

    const confirm = () => {
        props.callback()
        props.close()
    }
    
    return (
        <>
            {/* modal configuration */}
            <div className={props.show ? 'modal display-block' : 'modal display-none'}>
                <div className="modal-backdrop" onClick={props.close}>
                    <div className="modal-main">
                        <div className='modal-box' onClick={e => {e.stopPropagation()}}>
                            {/* header */}
                            <div className="modal-header">
                                <h3 className='description'>{props.description}</h3>
                                <button type="button" className="close" onClick={props.close}></button>
                            </div>
                            {/* Confirm/Cancel */}
                            <div className='modal-interaction-buttons'>
                                <button className="cancel-button" onClick={props.close}>Annuler</button>
                                <button className="confirm-button" onClick={confirm}>Confirmer</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export const ChangeModal = (props) => {

    const confirm = (event) => {
        event.preventDefault()
        console.log(props.userName)
        props.callback(props.userName, event.target.elements["modification"].value)
        props.close()
    }

    return (
        <>
            {/* modal configuration */}
            <div className={props.show ? 'modal display-block' : 'modal display-none'}>
                <div className="modal-backdrop" onClick={props.close}>
                    <div className="modal-main">
                        <div className='modal-box' onClick={e => {e.stopPropagation()}}>
                            {/* header */}
                            <div className="modal-header">
                                <h3 className='description'>{props.description}</h3>
                                <button type="button" className="close" onClick={props.close}></button>
                            </div>
                            {/* modal content */}
                            <form className='box' onSubmit={confirm}>
                                <label htmlFor="modification"><b>Modification</b></label>
                                {props.toModify === "list" ? 
                                // list handling
                                <select name='modification' defaultValue={props.listchoice[0]}>
                                {Object.keys(props.listchoice).map(key => (
                                    <option value={props.listchoice[key]}>{props.listchoice[key]}</option>
                                ))}
                                </select>
                                :
                                // default behaviour
                                <input type={props.toModify} defaultValue={props.userName} name="modification" required/>
                                }
                                {/* Confirm/Cancel */}
                                <div className='modal-interaction-buttons'>
                                    <button type="button" className="cancel-button" onClick={props.close}>Annuler</button>
                                    <button type="submit" value="Submit" className="confirm-button">Modifier</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}